"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteProps = getSiteProps;
exports.getUserProfile = getUserProfile;
exports.userProfileUpdated = userProfileUpdated;
exports.setInitialSiteProps = setInitialSiteProps;
exports.getUserProfileNow = void 0;

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _decorators = require("decorators");

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var profilePromise;
var sitePropsPromise;

function getSiteProps(fromLogout) {
  if (!sitePropsPromise) {
    sitePropsPromise = new _promisePolyfill.default(fetchSiteProps.bind(null, fromLogout));
  }

  return sitePropsPromise;
}

function fetchSiteProps(fromLogout, resolve) {
  var tgt = location.pathname + location.search;
  if (tgt.indexOf('?') == -1) tgt += '?';else tgt += '&';
  var fetchResponse;
  (0, _fetch.default)(tgt + 'sidebarFooterProps=1').then(function (response) {
    fetchResponse = response;
    return response.json();
  }).then(function (value) {
    if (value.notFoundPage && fromLogout) {
      history.replaceState({}, "", value.homeLink);
      fetchSiteProps(fromLogout, resolve);
    } else {
      var up = new URL(fetchResponse.url);
      up.searchParams.delete('sidebarFooterProps');
      up.hash = location.hash;
      history.replaceState(history.state, "", up.toString());
      resolve(value);
    }
  });
}

function getUserProfile() {
  if (!profilePromise) {
    profilePromise = new _promisePolyfill.default(fetchUserProfile);
  }

  return profilePromise;
}

function fetchUserProfile(resolve) {
  getSiteProps().then(function (value) {
    return resolve(value.userProfile);
  });
}

function userProfileUpdated() {
  var fromLogout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new _promisePolyfill.default(function (resolve) {
    sitePropsPromise = null;
    profilePromise = null;
    getSiteProps(fromLogout).then(function (value) {
      _SiteLayout.default.show(value);

      $(document).trigger($.Event('sitePropsUpdated', {
        siteProps: value
      }));
    });
    getUserProfile().then(function (profile) {
      $(document).trigger($.Event('profileUpdated', {
        profile: profile
      }));
      resolve(profile);
    });
  });
}

function setInitialSiteProps(props) {
  sitePropsPromise = _promisePolyfill.default.resolve(props);
  profilePromise = null;
}

var Switch = /*#__PURE__*/function () {
  function Switch() {
    babelHelpers.classCallCheck(this, Switch);
  }

  babelHelpers.createClass(Switch, null, [{
    key: "getProfile",
    value: function getProfile() {
      return null;
    }
  }]);
  return Switch;
}();

var getUserProfileNow = Switch.getProfile;
exports.getUserProfileNow = getUserProfileNow;